import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/image_layout/my_image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Fade"] */ "/vercel/path0/node_modules/react-awesome-reveal/dist/index.js");
